import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
// Country configuration with flag SVGs and names
const COUNTRY_CONFIG = {
  US: {
    name: 'the US',
    fullName: 'United States',
    flagSvg: <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-7">
        <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-8" />
        <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-9" />
        <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-10" />
        <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-11" />
      </svg>
  },
  UK: {
    name: 'the UK',
    fullName: 'United Kingdom',
    flagSvg: <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-12">
        <path fill="#f0f0f0" d="M0 0h512v512H0z" data-id="element-13" />
        <path fill="#d80027" d="M288 0h-64v208H0v96h224v208h64V304h224v-96H288z" data-id="element-14" />
        <path fill="#0052b4" d="M393.785 423.127L512 512h-45.255l-73.96-88.873zM311.652 423.127L512 512v-88.873zM118.215 423.127L0 512h45.255l73.96-88.873zM200.348 423.127L0 512v-88.873zM393.785 88.873L512 0h-45.255l-73.96 88.873zM311.652 88.873L512 0v88.873zM118.215 88.873L0 0h45.255l73.96 88.873zM200.348 88.873L0 0v88.873z" data-id="element-15" />
        <path fill="#d80027" d="M512 204.055v-70.07L322.483 256 512 377.945v-70.07L391.45 256zM0 204.055v-70.07L189.517 256 0 377.945v-70.07L120.55 256z" data-id="element-16" />
      </svg>
  },
  CA: {
    name: 'Canada',
    fullName: 'Canada',
    flagSvg: <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-17">
        <path fill="#f0f0f0" d="M128 0h256v512H128z" data-id="element-18" />
        <path fill="#d80027" d="M0 0h128v512H0zm384 0h128v512H384z" data-id="element-19" />
        <path fill="#d80027" d="M256 128l-16 48h-48l40 32-16 48 40-32 40 32-16-48 40-32h-48z" data-id="element-20" />
      </svg>
  },
  AU: {
    name: 'Australia',
    fullName: 'Australia',
    flagSvg: <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-21">
        <path fill="#0052b4" d="M0 0h512v512H0z" data-id="element-22" />
        <path fill="#f0f0f0" d="M0 0h256v256H0z" data-id="element-23" />
        <path fill="#d80027" d="M144 0h-32v104H0v32h112v120h32V136h112v-32H144z" data-id="element-24" />
        <path fill="#0052b4" d="M0 0v24l96 72H128L32 24V0zm256 0v24l-96 72H128l96-72V0zM0 256v-24l96-72H128L32 232v24zm256 0v-24l-96-72H128l96 72v24z" data-id="element-25" />
        <path fill="#d80027" d="M256 88.348L181.652 24H160v14.71L224 88.348V112h32V88.348zM74.348 0L0 51.942V72h14.71L88.348 24H112V0H74.348zM256 167.652L181.652 232H160v-14.71L224 167.652V144h32v23.652zM74.348 256L0 204.058V184h14.71L88.348 232H112v24H74.348z" data-id="element-26" />
        <path fill="#f0f0f0" d="M256 384l-8 24-24-8 8 24-24 8 24 8-8 24 24-8 8 24 8-24 24 8-8-24 24-8-24-8 8-24-24 8zm-96 64l-4 12-12-4 4 12-12 4 12 4-4 12 12-4 4 12 4-12 12 4-4-12 12-4-12-4 4-12-12 4zm192-32l-4 12-12-4 4 12-12 4 12 4-4 12 12-4 4 12 4-12 12 4-4-12 12-4-12-4 4-12-12 4zm32 96l-4 12-12-4 4 12-12 4 12 4-4 12 12-4 4 12 4-12 12 4-4-12 12-4-12-4 4-12-12 4zm-64-160l-4 12-12-4 4 12-12 4 12 4-4 12 12-4 4 12 4-12 12 4-4-12 12-4-12-4 4-12-12 4z" data-id="element-27" />
      </svg>
  }
};
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const [userCountry, setUserCountry] = useState<'US' | 'UK' | 'CA' | 'AU'>('US');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          // Set city
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
          // Set country - map country codes to our supported countries
          if (data.country) {
            const countryCode = data.country.toUpperCase();
            console.log(`User country detected: ${countryCode}`);
            // Map country codes to our supported countries
            if (countryCode === 'GB') {
              setUserCountry('UK');
            } else if (countryCode === 'CA') {
              setUserCountry('CA');
            } else if (countryCode === 'AU') {
              setUserCountry('AU');
            } else {
              // Default to US for all other countries
              setUserCountry('US');
            }
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
        // Keep defaults if there's an error
      }
    };
    fetchUserLocation();
  }, []);
  // Get current country configuration
  const countryConfig = COUNTRY_CONFIG[userCountry];
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-28">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-29">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-30">
          <div className="flex items-center" data-id="element-31">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-32">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-33" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-34">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-35">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-36">
              {countryConfig.flagSvg}
            </div>
            <span className="text-sm" data-id="element-37">
              Trending in {countryConfig.fullName}
            </span>
          </div>
        </div>
      </div>
      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-38">
        <div className="container mx-auto px-4 py-3" data-id="element-39">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-40">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>
      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-41">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-42">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-43" />
          <p className="font-bold text-sm sm:text-base" data-id="element-44">
            UPDATE: Elivara Compression Leggings Are Selling Out FAST! Grab
            Yours NOW to get up to 40% OFF + Fast FREE Shipping Across{' '}
            {countryConfig.fullName}
          </p>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-45">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-46">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-47">
            <div className="py-6 px-0 md:px-4" data-id="element-48">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-49">
                {userCity} Doctors Reveal: Lipedema Could Be the Real Reason
                You're Avoiding Dating (And the Compression Breakthrough That's
                Helping Women Feel Confident Again)
              </h1>
              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-50">
                Up to 17 million women in {countryConfig.name} have lipedema —
                and many avoid dating or intimacy because they're ashamed of how
                their legs look. A new compression breakthrough is helping them
                finally feel comfortable in their own skin.
              </p>
              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-51">
                <div className="flex items-center" data-id="element-52">
                  <p className="text-sm text-gray-700" data-id="element-53">
                    By Sarah Mitchell, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-54">
                  <EyeIcon size={16} className="mr-1" data-id="element-55" />
                  <span data-id="element-56">247,891</span>
                </div>
              </div>
              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-57">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hb7663489Vj6W5fHFmd7JR/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_21_%CF%80.%CE%BC..png" alt="Image of a woman looking frustrated while measuring her legs, showing visible disproportionate size compared to her upper body" className="w-full h-auto" data-id="element-58" />
              </div>
              {/* Personal Story Section */}
              <div className="mb-10" data-id="element-59">
                <p className="mb-4" data-id="element-60">
                  I'll never forget the night I matched with him on the dating
                  app.
                </p>
                <p className="mb-4" data-id="element-61">
                  He was exactly my type. Funny. Smart. Kind messages. He asked
                  me out for coffee.
                </p>
                <p className="mb-4" data-id="element-62">And I panicked.</p>
                <p className="mb-4" data-id="element-63">
                  Because I knew what would happen. We'd meet. We'd talk. We'd
                  laugh. And if things went well, he'd eventually want to see me
                  in something other than long pants.
                </p>
                <p className="mb-4" data-id="element-64">
                  A dress. Shorts. A swimsuit. My actual body.
                </p>
                <p className="mb-4" data-id="element-65">And then he'd see my legs.</p>
                <p className="mb-4" data-id="element-66">
                  I canceled the date. Made up an excuse. Unmatched him.
                </p>
                <p className="mb-4" data-id="element-67">
                  It wasn't the first time. And it wouldn't be the last.
                </p>
                <p className="mb-4" data-id="element-68">
                  I wanted to date. I wanted intimacy. I wanted love.
                </p>
                <p className="mb-4" data-id="element-69">
                  But I couldn't get past the shame of my legs.
                </p>
                <p className="mb-4" data-id="element-70">
                  I spent years like this. Matching with men. Canceling dates.
                  Sabotaging any chance at a relationship before it could even
                  start.
                </p>
                <p className="mb-4" data-id="element-71">
                  Because in my head, I knew how it would end. He'd see my legs
                  and be horrified. Or worse — he'd be polite about it but lose
                  interest.
                </p>
                <p className="mb-4 font-semibold" data-id="element-72">Sound familiar?</p>
                <p className="mb-4" data-id="element-73">
                  If you've avoided dating because you're ashamed of how
                  lipedema makes your legs look — if you've canceled dates,
                  avoided intimacy, or sabotaged relationships because you
                  couldn't stand the thought of someone seeing your body — I
                  need you to keep reading.
                </p>
                <p className="mb-4" data-id="element-74">
                  Because what I discovered changed everything. And it might
                  change everything for you too.
                </p>
              </div>
              {/* The Hidden Condition Section - This marks the end of the first two sections */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-75">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-76">
                  The Hidden Condition That Steals More Than Your Confidence
                </h2>
                {/* Medical Condition Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-77">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m9g7umpbQUcEETPScspXRj/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_23_%CF%80.%CE%BC..png" alt="Medical illustration showing the difference between normal fat tissue and lipedema fat tissue, highlighting the fluid buildup and inflammation" className="w-full h-auto" data-id="element-78" />
                </div>
                <p className="mb-4" data-id="element-79">
                  It turns out, I wasn't broken. I wasn't lazy. And I wasn't
                  "letting myself go."
                </p>
                <p className="mb-4" data-id="element-80">
                  I had a legitimate medical condition called lipedema. And
                  according to the National Institutes of Health, it affects an
                  estimated 11% of women in the United States alone.
                </p>
                <p className="mb-4" data-id="element-81">
                  That's roughly 17 million women. Many of them are single. Many
                  of them want relationships. And many of them are hiding.
                </p>
                <p className="mb-4" data-id="element-82">Here's what lipedema actually is:</p>
                <p className="mb-4" data-id="element-83">
                  Lipedema is a disorder of fatty tissue. Fat accumulates
                  abnormally in your legs and sometimes arms. It creates a
                  disproportionate appearance.
                </p>
                <p className="mb-4" data-id="element-84">
                  The fat cells in lipedema are different from normal fat cells.
                  They're dysfunctional. They're inflamed. And they trap fluid
                  in the tissue.
                </p>
                <p className="mb-4" data-id="element-85">The telltale signs include:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-86">
                  <li data-id="element-87">
                    Disproportionately large legs compared to your upper body
                  </li>
                  <li data-id="element-88">Fat that doesn't respond to diet or exercise</li>
                  <li data-id="element-89">Legs that are painful, tender to touch, or feel heavy</li>
                  <li data-id="element-90">Easy bruising on the legs</li>
                  <li data-id="element-91">
                    Symmetrical fat distribution (both legs affected equally)
                  </li>
                  <li data-id="element-92">Swelling that worsens as the day goes on</li>
                </ul>
                <p className="mb-4" data-id="element-93">
                  You probably already know all of this. You've lived with it
                  for years.
                </p>
                <p className="mb-4" data-id="element-94">
                  But here's what lipedema steals from you that most people
                  don't talk about:
                </p>
                <p className="mb-4 font-semibold" data-id="element-95">
                  It steals dating. It steals intimacy. It steals relationships.
                </p>
                <p className="mb-4" data-id="element-96">
                  You avoid first dates because you don't want to explain why
                  you always wear pants.
                </p>
                <p className="mb-4" data-id="element-97">
                  You avoid second dates because you're terrified they'll want
                  to go somewhere that requires shorts or a dress.
                </p>
                <p className="mb-4" data-id="element-98">
                  You avoid third dates because intimacy means being naked. And
                  being naked means they'll see your legs in full light.
                </p>
                <p className="mb-4" data-id="element-99">And the shame spiral continues.</p>
                <p className="mb-4" data-id="element-100">
                  Most doctors miss lipedema completely. They look at your legs
                  and immediately jump to obesity. They tell you to lose weight.
                  They don't understand that lipedema fat is fundamentally
                  different from regular fat.
                </p>
                <p className="mb-4" data-id="element-101">
                  It's why you can diet and exercise until you're exhausted.
                  Your arms get toned. Your face slims down. Your waist gets
                  smaller.
                </p>
                <p className="mb-4" data-id="element-102">
                  But your legs? They stay exactly the same size.
                </p>
                <p className="mb-4" data-id="element-103">
                  This isn't about willpower. This isn't about laziness.
                </p>
                <p className="mb-4" data-id="element-104">
                  This is about biology. And it's been keeping you from love.
                </p>
                <p className="mb-4" data-id="element-105">
                  For years, I thought I was the only one. I thought I was alone
                  in this shame.
                </p>
                <p className="mb-4" data-id="element-106">
                  But once I finally got my diagnosis, I realized there were
                  millions of women out there experiencing the exact same thing.
                  Women avoiding dating. Women canceling plans. Women choosing
                  loneliness over the risk of rejection.
                </p>
              </div>
              {/* Why Everything You've Tried Hasn't Worked Section */}
              <div className="mb-10" data-id="element-107">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-108">
                  Why Hiding Doesn't Work (And What Does)
                </h2>
                {/* Traditional Compression Stockings Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-109">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vZgTaXaxfHgpWtLhRDNWGn/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_30_%CF%80.%CE%BC..png" alt="Image showing traditional medical-grade compression stockings next to a frustrated woman trying to put them on, illustrating how uncomfortable and medical they look" className="w-full h-auto" data-id="element-110" />
                </div>
                <p className="mb-4" data-id="element-111">
                  Once I understood what lipedema was, I had a choice.
                </p>
                <p className="mb-4" data-id="element-112">
                  I could keep hiding. Or I could try to manage it.
                </p>
                <p className="mb-4" data-id="element-113">
                  My doctor recommended compression stockings. You know, those
                  thick, medical-grade stockings. The ones that are impossible
                  to put on. The ones that look like something your grandmother
                  would wear.
                </p>
                <p className="mb-4" data-id="element-114">I tried them. For about two weeks.</p>
                <p className="mb-4" data-id="element-115">
                  And honestly? They made me feel WORSE about my body.
                </p>
                <p className="mb-4" data-id="element-116">
                  Here's why standard compression doesn't work when you're
                  trying to feel confident:
                </p>
                <div className="bg-red-50 p-4 rounded-md mb-6" data-id="element-117">
                  <p className="font-semibold mb-2" data-id="element-118">
                    Problem #1: They Look Medical
                  </p>
                  <p className="mb-3" data-id="element-119">
                    Traditional compression stockings are thick. Beige.
                    Obviously medical.
                  </p>
                  <p className="mb-3" data-id="element-120">
                    You can't wear them under a dress. You definitely can't wear
                    them with shorts or a skirt.
                  </p>
                  <p className="mb-3" data-id="element-121">
                    So you're back to long pants. Back to hiding. Back to
                    avoiding any situation where your legs might show.
                  </p>
                  <p className="mb-3" data-id="element-122">
                    Which means avoiding dates. Avoiding pools. Avoiding
                    beaches. Avoiding any chance at intimacy.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-123">
                    Problem #2: They Don't Actually Fix the Swelling
                  </p>
                  <p className="mb-3" data-id="element-124">
                    Most compression garments use uniform pressure from top to
                    bottom. They squeeze your legs with the same intensity
                    everywhere.
                  </p>
                  <p className="mb-3" data-id="element-125">
                    But your lymphatic system doesn't work that way. It needs
                    directional support to move fluid upward and out.
                  </p>
                  <p className="mb-3" data-id="element-126">
                    Without that gradient, fluid just gets squeezed with nowhere
                    to go. Your legs don't get smaller. They don't look better.
                  </p>
                  <p className="mb-3" data-id="element-127">
                    So even when you wear compression, you still feel ashamed of
                    your legs.
                  </p>
                  <p className="font-semibold mb-2" data-id="element-128">
                    Problem #3: They're Unbearable to Wear
                  </p>
                  <p className="mb-3" data-id="element-129">
                    Let's be real. If you're going on a date, the last thing you
                    want is compression stockings that:
                  </p>
                  <ul className="list-disc pl-6 mb-3 space-y-1" data-id="element-130">
                    <li data-id="element-131">Dig into your skin</li>
                    <li data-id="element-132">Make you sweat</li>
                    <li data-id="element-133">Roll down by dinnertime</li>
                    <li data-id="element-134">Create painful marks on your thighs</li>
                  </ul>
                  <p className="mb-3" data-id="element-135">
                    You're already nervous about the date. You're already
                    worried about your legs.
                  </p>
                  <p data-id="element-136">
                    Adding uncomfortable compression that you dread wearing?
                    That's not helping.
                  </p>
                </div>
                <p className="mb-4" data-id="element-137">I felt stuck.</p>
                <p className="mb-4" data-id="element-138">
                  The only "solution" available made me feel MORE
                  self-conscious. Not less.
                </p>
                <p className="mb-4" data-id="element-139">
                  That's when I realized: the problem wasn't compression itself.
                  It was the wrong kind of compression.
                </p>
                <p className="mb-4" data-id="element-140">
                  There had to be something that actually reduced swelling. That
                  looked normal. That I'd actually want to wear.
                </p>
                <p className="mb-4" data-id="element-141">
                  Something that would let me stop thinking about my legs every
                  second of every date.
                </p>
              </div>
              {/* The Breakthrough Section */}
              <div className="mb-10" data-id="element-142">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-143">
                  The Breakthrough That Changed My Dating Life
                </h2>
                {/* Elivara Leggings Product Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-144">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qXr4YxNDa3ZLDxwoFvkcy4/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_34_%CF%80.%CE%BC..png" alt="Image of Elivara compression leggings showing the stylish design with FlowMapping™ technology zones highlighted with glowing orange lines" className="w-full h-auto" data-id="element-145" />
                </div>
                <p className="mb-4" data-id="element-146">
                  That's when I discovered Elivara — and specifically, their
                  revolutionary FlowMapping™ Compression technology.
                </p>
                <p className="mb-4" data-id="element-147">
                  When I first heard about it, I was skeptical. Another
                  compression product? Really?
                </p>
                <p className="mb-4" data-id="element-148">
                  But Elivara is fundamentally different from anything else on
                  the market.
                </p>
                <p className="mb-4" data-id="element-149">
                  And the difference comes down to one key insight: Your body
                  has natural pathways for lymphatic drainage. Compression needs
                  to follow those pathways — not fight against them.
                </p>
                <p className="mb-4" data-id="element-150">Here's how FlowMapping™ actually works:</p>
                <p className="mb-4" data-id="element-151">
                  Instead of applying uniform pressure across your entire leg,
                  Elivara uses graduated pressure zones. These zones are
                  specifically designed to match your body's lymphatic system.
                </p>
                <p className="mb-4" data-id="element-152">
                  Think of it like this: Your lymphatic fluid needs to move in a
                  specific direction. Up and out of your legs. Back toward your
                  core.
                </p>
                <p className="mb-4" data-id="element-153">
                  FlowMapping™ creates a gentle pressure gradient that guides
                  trapped fluid along your natural drainage pathways. It
                  accelerates lymphatic flow without creating that uncomfortable
                  tourniquet effect.
                </p>
                <p className="mb-4" data-id="element-154">
                  The pressure is strongest at your ankles. That's where fluid
                  tends to pool the most.
                </p>
                <p className="mb-4" data-id="element-155">
                  Then it gradually decreases as it moves up your leg. 20 at the
                  calf. 18 at the knee. 15 at the thigh.
                </p>
                <p className="mb-4" data-id="element-156">
                  This gradient naturally encourages fluid to move upward and
                  drain properly, rather than getting stuck.
                </p>
                <p className="mb-4" data-id="element-157">
                  But here's what really sets Elivara apart:
                </p>
                <p className="mb-4" data-id="element-158">
                  They designed these specifically for women with lipedema who
                  want to live normal lives. Who want to date. Who want to feel
                  confident.
                </p>
                <p className="mb-4" data-id="element-159">
                  Most compression garments are made for generic swelling or
                  elderly patients.
                </p>
                <p className="mb-4" data-id="element-160">
                  Elivara spent years studying lipedema. Understanding the
                  unique fat distribution patterns. The specific areas where
                  fluid accumulates. The tender zones where pressure needs to be
                  gentler.
                </p>
                <p className="mb-4" data-id="element-161">The result?</p>
                <p className="mb-4" data-id="element-162">
                  Leggings that deliver therapeutic-level relief while looking
                  and feeling like regular athleisure wear.
                </p>
                <p className="mb-4" data-id="element-163">
                  You can wear them on a date. To the beach. On vacation. To
                  bed.
                </p>
                <p className="mb-4" data-id="element-164">
                  They don't look medical. They don't scream "I have a
                  condition."
                </p>
                <p className="mb-4" data-id="element-165">
                  They just look like stylish leggings. That happen to actually
                  reduce swelling.
                </p>
                <p className="mb-4 font-semibold" data-id="element-166">
                  I'm not exaggerating when I say these changed my dating life.
                </p>
              </div>
              {/* New Section: Visual Explanation of FlowMapping™ Technology */}
              <div className="mb-10" data-id="element-167">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-168">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden bg-blue-50 p-4" data-id="element-169">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ge5gzuHf48wNS9HaJaGCz/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b.webp" alt="Animation showing the difference between painful lipedema fluid buildup (left, red areas) and the FlowMapping™ technology directing fluid flow (right, green chevrons)" className="w-full h-auto mx-auto" data-id="element-170" />
                  <div className="flex justify-between mt-4 text-sm md:text-base" data-id="element-171">
                    <div className="text-center w-1/2 border-r border-blue-200 pr-2" data-id="element-172">
                      <p className="font-bold text-red-500 mb-1" data-id="element-173">
                        WITHOUT SUPPORT
                      </p>
                      <p className="text-gray-700" data-id="element-174">
                        Painful fluid buildup and inflammation
                      </p>
                    </div>
                    <div className="text-center w-1/2 pl-2" data-id="element-175">
                      <p className="font-bold text-green-500 mb-1" data-id="element-176">
                        WITH FLOWMAPPING™
                      </p>
                      <p className="text-gray-700" data-id="element-177">
                        Guided fluid drainage along natural pathways
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-178">
                  This visual perfectly captures what makes FlowMapping™
                  technology so revolutionary. On the left, you can see what
                  happens in lipedema-affected legs: fluid builds up (shown in
                  red), creating painful inflammation and swelling that doesn't
                  respond to diet or exercise.
                </p>
                <p className="mb-4" data-id="element-179">
                  On the right, you see how Elivara's patented FlowMapping™
                  technology works. The strategically placed compression zones
                  (shown as green chevrons) create directional pressure that
                  guides trapped fluid along your natural lymphatic pathways.
                  This helps your body drain the fluid properly, reducing
                  swelling, pain, and that heavy feeling that comes with
                  lipedema.
                </p>
                <p className="mb-4" data-id="element-180">
                  The chevron patterns aren't just for show—they represent the
                  actual directional support built into every pair of Elivara
                  leggings. This is why women report feeling immediate relief
                  when they put them on. The technology is actively working with
                  your body's natural systems, not against them.
                </p>
              </div>
              {/* What It Actually Feels Like Section */}
              <div className="mb-10" data-id="element-181">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-182">
                  What It Actually Feels Like to Wear Them (On a Date)
                </h2>
                {/* Woman Wearing Elivara Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-183">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oMv6AwMrRLHqTtLr2LbQQk/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_36_%CF%80.%CE%BC..png" alt="Image of a smiling woman wearing Elivara leggings while doing everyday activities, showing how they look like normal leggings but provide therapeutic benefits" className="w-full h-auto" data-id="element-184" />
                </div>
                <p className="mb-4" data-id="element-185">
                  The first time I wore my Elivara leggings on a date, I noticed
                  something incredible.
                </p>
                <p className="mb-4" data-id="element-186">I forgot about my legs.</p>
                <p className="mb-4" data-id="element-187">
                  Not completely. But for the first time in years, I wasn't
                  constantly thinking about them.
                </p>
                <p className="mb-4" data-id="element-188">
                  I wasn't wondering if he was looking at my legs. I wasn't
                  comparing my legs to other women's legs at nearby tables. I
                  wasn't planning my escape route if the conversation turned to
                  summer activities.
                </p>
                <p className="mb-4" data-id="element-189">
                  I was just... present. On the date. Having a conversation.
                </p>
                <p className="mb-4" data-id="element-190">
                  Within an hour of wearing them, my legs felt lighter. That
                  heavy, swollen feeling I'd gotten so used to started to ease.
                </p>
                <p className="mb-4" data-id="element-191">
                  By the end of the date — when my legs were usually at their
                  worst — they felt better than they normally did first thing in
                  the morning.
                </p>
                <p className="mb-4" data-id="element-192">
                  I started wearing them every single day. And the changes kept
                  coming:
                </p>
                <div className="space-y-4 mb-6" data-id="element-193">
                  <div className="flex items-start" data-id="element-194">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-195" />
                    <p data-id="element-196">
                      <span className="font-semibold" data-id="element-197">
                        My legs looked slimmer.
                      </span>{' '}
                      The constant swelling that made my legs appear even larger
                      started to reduce. I could see more definition. More
                      shape. Less of that "column" appearance. For the first
                      time, I looked in the mirror and thought: "Maybe I could
                      wear a dress."
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-198">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-199" />
                    <p data-id="element-200">
                      <span className="font-semibold" data-id="element-201">
                        The pain decreased significantly.
                      </span>{' '}
                      Lipedema legs are often tender and painful to the touch.
                      The FlowMapping™ compression reduced inflammation and
                      fluid buildup. That meant less pain. Less tenderness.
                      Fewer random bruises. And less fear about someone touching
                      my legs.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-202">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-203" />
                    <p data-id="element-204">
                      <span className="font-semibold" data-id="element-205">I had more energy.</span>{' '}
                      When you're carrying around excess fluid in your legs all
                      day, it's exhausting. Once that fluid started draining
                      properly, I genuinely had more energy to get through my
                      day. Energy to go on dates. Energy to say yes to
                      activities.
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-206">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-207" />
                    <p data-id="element-208">
                      <span className="font-semibold" data-id="element-209">I stopped hiding.</span>{' '}
                      This was the big one. I started wearing dresses again. I
                      went to the beach with friends. I stopped obsessing over
                      finding the longest pants possible to cover my legs. I
                      went on a second date. A third date. A fourth. Because for
                      the first time in years, I didn't feel like I had to
                      choose between dating and hiding my body.
                    </p>
                  </div>
                </div>
                <p className="mb-4 font-semibold" data-id="element-210">
                  Elivara gave me something I thought I'd lost forever: the
                  freedom to be seen.
                </p>
              </div>
              {/* Testimonials Section */}
              <div className="mb-10" data-id="element-211">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-212">
                  Real Women Who Started Dating Again
                </h2>
                {/* Before/After Results Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-213">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8J75MXwWaCcwc1FvqhjnYB/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_42_%CF%80.%CE%BC..png" alt="Before and after comparison showing 'Without Support' vs 'With Elivara' illustrating the visible reduction in swelling and improved leg shape" className="w-full h-auto" data-id="element-214" />
                </div>
                <p className="mb-6" data-id="element-215">
                  I'm not the only one who's experienced this transformation.
                  Thousands of women with lipedema have discovered Elivara.
                  Here's what they say about dating and confidence:
                </p>
                <div className="space-y-6 mb-6" data-id="element-216">
                  <TestimonialCard quote="For years I avoided dating completely. I told myself I was too busy. But really? I was terrified of someone seeing my legs. These leggings gave me back my confidence. I've been on three dates in the past month. THREE. I haven't been on three dates in three YEARS. They look like regular leggings. But they actually reduce my swelling. I can wear dresses now without panicking." author="Michelle T." age="45" location="Denver, CO" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-217" />
                  <TestimonialCard quote="I sabotaged every relationship before it could get serious. I'd ghost guys. Make up excuses. Anything to avoid the moment they'd see my body. Finding Elivara changed that. My legs look better. They FEEL better. And most importantly — I'm not thinking about them constantly anymore. I'm actually in a relationship now. A real one. And he's never once said anything negative about my legs. All that fear was in my head." author="Sarah W." age="39" location="Seattle, WA" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-218" />
                  <TestimonialCard quote="I cried when I put these on. Not because they hurt — because I realized how long I'd been avoiding life. I'd stopped going to the beach. Stopped dating. Stopped wearing anything that showed my legs. These leggings don't fix everything. But they reduce my swelling enough that I feel okay being seen. That's HUGE." author="Jessica R." age="42" location="Portland, OR" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-219" />
                  <TestimonialCard quote="My legs are lighter. My pain is less. And I finally feel like myself again. I went on a beach trip with friends last month. First time in 5 years. I wore these under a sundress. No one even noticed. But I noticed. I noticed that I was having fun instead of hiding." author="Amanda K." age="38" location="Austin, TX" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hq1HCFwLGMXQeBfL6EFNpY/istockphoto-1180524344-612x612.jpg" data-id="element-220" />
                  <TestimonialCard quote="For years I thought I was just destined to be alone. Who would want someone with legs like mine? Turns out, the only person who couldn't get past my legs was ME. Finding out I had lipedema was validating. Finding compression that actually works was life-changing. I'm dating again. Actually giving people a chance. And it feels amazing." author="Rebecca L." age="44" location="Nashville, TN" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/vLXJxevCdw389ZygZwFFUQ/Screenshot_2025-09-30_at_00.02.43.png" data-id="element-221" />
                </div>
              </div>
              {/* Why Elivara Works Section */}
              <div className="mb-10" data-id="element-222">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-223">
                  Why Elivara Works When Everything Else Failed
                </h2>
                <p className="mb-4" data-id="element-224">
                  You might be wondering: What makes Elivara so different from
                  all the other compression products out there?
                </p>
                <p className="mb-4" data-id="element-225">It comes down to three key factors:</p>
                {/* FlowMapping Technology Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-226">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sngffNnPS6asvvdqPakuVW/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_52_%CF%80.%CE%BC..png" alt="Illustration comparing Traditional Compression with uniform pressure versus FlowMapping™ Technology with directional support following the lymphatic system pathways" className="w-full h-auto" data-id="element-227" />
                </div>
                <div className="space-y-6 mb-6" data-id="element-228">
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-229">
                    <h3 className="font-bold text-lg mb-2" data-id="element-230">
                      1. Lipedema-Specific Design
                    </h3>
                    <p data-id="element-231">
                      Elivara isn't generic compression. Every single design
                      element is based on research into lipedema. How the fat
                      distributes. Where fluid accumulates. Which areas are most
                      tender. How the lymphatic system needs to drain. This
                      isn't a one-size-fits-all solution adapted for lipedema.
                      It's built from the ground up specifically for women with
                      this condition. Women who want to date. Women who want to
                      feel confident. Women who are tired of hiding.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-232">
                    <h3 className="font-bold text-lg mb-2" data-id="element-233">
                      2. FlowMapping™ Technology
                    </h3>
                    <p data-id="element-234">
                      The graduated pressure system doesn't just squeeze your
                      legs randomly. It creates a precise pressure gradient that
                      follows your body's natural lymphatic pathways. It gently
                      guides trapped fluid where it needs to go. Think of it
                      like this: Squeezing a water balloon doesn't drain it. It
                      just moves the water around without releasing it. But
                      creating a channel? Creating a drainage pathway? That
                      allows the water to flow out. That's what FlowMapping™
                      does for trapped lymphatic fluid. And that's why your legs
                      actually get smaller. Visibly smaller.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-235">
                    <h3 className="font-bold text-lg mb-2" data-id="element-236">
                      3. Looks Like Regular Leggings
                    </h3>
                    <p data-id="element-237">
                      Here's what really sets Elivara apart: They understand
                      that a solution only works if you actually use it. That's
                      why these leggings look stylish. Feel comfortable. And
                      work with your life instead of against it. You can wear
                      them on dates. To work. To the gym. Running errands. Out
                      to dinner. They don't look medical. They don't scream "I
                      have a condition." They just look like great leggings.
                      That happen to provide therapeutic-level relief. This is
                      critical for confidence. Because if your compression makes
                      you feel MORE self-conscious, you won't wear it. And if
                      you don't wear it, it can't help you.
                    </p>
                  </div>
                </div>
              </div>
              {/* First CTA Section - Removed the button */}
              <div className="mb-10 bg-gray-100 p-6 rounded-lg" data-id="element-238">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-239">
                  This Is Your Chance to Stop Hiding
                </h2>
                {/* Product Packaging Image */}
                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-240">
                  <img src="https://cdn.magicpatterns.com/uploads/9c4VRDNymRqFdo3Z3aY26W/Trusted_by_Women_Across_the_USA_(1).png" alt="Elivara Lipedema Leggings with premium packaging, 30-day money back guarantee, and free shipping" className="w-full h-auto" data-id="element-241" />
                </div>
                <p className="mb-4" data-id="element-242">Here's something you should know:</p>
                <p className="mb-4" data-id="element-243">
                  Because of the specialized FlowMapping™ technology and the
                  lipedema-specific design, Elivara can only produce limited
                  quantities of these leggings.
                </p>
                <p className="mb-4" data-id="element-244">
                  And right now, they're offering first-time customers an
                  exclusive opportunity to save 40% off their order.
                </p>
                <p className="mb-4" data-id="element-245">
                  This isn't a permanent discount. It's specifically designed to
                  help women who've been avoiding dating or hiding because of
                  lipedema finally access a solution that actually works.
                </p>
                <p className="mb-4" data-id="element-246">
                  But here's the reality: these sell out. Fast.
                </p>
                <p className="mb-4" data-id="element-247">
                  When women with lipedema discover compression that actually
                  reduces swelling AND looks like regular leggings, word
                  spreads.
                </p>
                <p className="mb-4" data-id="element-248">
                  Popular sizes disappear in days. And when they're gone, you'll
                  have to wait for the next production run to get your hands on
                  a pair.
                </p>
                <p className="mb-4 font-semibold" data-id="element-249">
                  I don't want you to miss this opportunity.
                </p>
                <p className="mb-4" data-id="element-250">
                  If you've been avoiding dating because you're ashamed of your
                  legs...
                </p>
                <p className="mb-4" data-id="element-251">
                  If you've canceled plans, ghosted matches, or sabotaged
                  relationships because you couldn't stand the thought of
                  someone seeing your body...
                </p>
                <p className="mb-4" data-id="element-252">
                  If you're tired of choosing between love and hiding...
                </p>
                <p className="mb-4" data-id="element-253">This is your chance to change that.</p>
              </div>
              {/* You Deserve Section - Removed the button */}
              <div className="mb-10" data-id="element-254">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-255">
                  You Deserve to Be Seen
                </h2>
                {/* Lifestyle Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-256">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Woman confidently walking on the beach wearing a dress with compression leggings, enjoying freedom and comfort after using Elivara to manage her lipedema" className="w-full h-auto" data-id="element-257" />
                </div>
                <p className="mb-4" data-id="element-258">
                  I want you to imagine something for a moment.
                </p>
                <p className="mb-4" data-id="element-259">
                  Imagine going on a date and actually enjoying it. Not spending
                  the whole time worried about your legs.
                </p>
                <p className="mb-4" data-id="element-260">
                  Imagine wearing a dress in the summer without a second
                  thought. Going to the beach with friends. Saying yes when
                  someone asks you out.
                </p>
                <p className="mb-4" data-id="element-261">
                  Imagine being intimate with someone without the paralyzing
                  fear of them seeing your body in full light.
                </p>
                <p className="mb-4" data-id="element-262">
                  Imagine just... living. Dating. Being open to love.
                </p>
                <p className="mb-4" data-id="element-263">Without lipedema holding you back.</p>
                <p className="mb-4" data-id="element-264">
                  That's what Elivara gave me. And that's what it can give you.
                </p>
                <p className="mb-4" data-id="element-265">
                  You're not alone. You're not broken. And you're not imagining
                  this condition.
                </p>
                <p className="mb-4" data-id="element-266">
                  Lipedema is real. It's valid. And it shouldn't steal your
                  chance at love.
                </p>
                <p className="mb-6 font-semibold" data-id="element-267">Try Elivara for 60 days.</p>
                <p className="mb-4" data-id="element-268">
                  Wear them on dates. To social events. Anywhere you've been
                  avoiding because of your legs.
                </p>
                <p className="mb-4" data-id="element-269">
                  If they don't reduce your swelling enough to make you feel
                  more confident, return them. Full refund. No questions asked.
                </p>
                <p className="mb-4" data-id="element-270">
                  The only risk is missing this opportunity. Missing your chance
                  to stop hiding.
                </p>
                <p className="mb-4" data-id="element-271">
                  Don't let another year go by alone because lipedema convinced
                  you that you're not worthy of love.
                </p>
                <p className="mb-4 font-semibold" data-id="element-272">
                  You are. And your legs don't change that.
                </p>
              </div>
            </div>
          </main>
          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-273">
            <div className="sticky top-6" data-id="element-274">
              <StickyCTA showNewImage={true} countryName={countryConfig.name} data-id="element-275" />
            </div>
          </aside>
        </div>
      </div>
      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-276">
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-277">
          GET 40% OFF ELIVARA LEGGINGS NOW!
        </a>
      </div>
      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-278">
        <div className="container mx-auto px-4 py-6" data-id="element-279">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-280">
            <div className="flex items-center" data-id="element-281">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-282" />
              <p className="font-bold text-lg" data-id="element-283">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-284">
              Get Elivara Compression Leggings at 40% OFF + FREE Shipping for a
              Limited Time!
            </p>
            <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-285">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>
      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-286">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-287">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-288">
            <p className="mb-2" data-id="element-289">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-290">
              <span data-id="element-291">About Us</span>
              <span data-id="element-292">|</span>
              <span data-id="element-293">Terms of Use</span>
              <span data-id="element-294">|</span>
              <span data-id="element-295">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-296">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-297">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};